import styled from '@emotion/styled';
import { Button, Container } from '@presentation/components';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';
import { Link } from 'react-router-dom';

export const TopSection = styled.section`
  background-color: ${(props) => props.theme.color.blue.lightBlue};
  position: relative;
  padding-top: 50px;
  padding-bottom: 75px;
  color: ${(props) => props.theme.color.blue.default};
  text-align: center;
`;

export const TopTitle = styled.h1`
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  ${responsiveFontSize(44, 6)}
  letter-spacing: 0;
  margin: 10px auto;

  ${mediaQuery('phone')} {
    font-size: 28px;
  }
`;

export const TopContainer = styled(Container)``;

export const TopSubtitle = styled.h2`
  ${responsiveFontSize(26, 2)}
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 40px;
`;

export const TopButton = styled(Button)`
  margin-bottom: 20px;
  min-width: 300px;

  ${mediaQuery('tablet')} {
    min-width: auto;
  }
`;

export const TopSeparation = styled.img`
  position: absolute;
  z-index: 1;
  bottom: -40px;
  left: 0px;
  width: 100%;

  ${mediaQuery('max')} {
    bottom: 0px;
  }
`;

export const ScrollArrowWrapper = styled.div`
  pointer-events: none;
  padding: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  ${mediaQuery('tablet')} {
    display: none;
  }
`;

export const AccordionWrapper = styled.div`
  max-width: 800px;
  margin: 75px auto;
`;

export const AccordionContent = styled.p`
  margin: 0;
  padding: 20px;
`;

// STEPS

export const StepCardContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

export const StepButton = styled(Button)`
  margin-top: 20px;
  margin-bottom: 75px;
  ${mediaQuery('small', 'min')} {
    min-width: 300px;
  }
`;

export const StepCardWrapper = styled.div`
  padding: 20px;
`;

export const StepCard = styled.div`
  max-width: 350px;
  box-shadow: 0px 0px 90px #00000029;
  height: 380px;
  background-color: ${(props) => props.theme.color.light.default};
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  text-align: center;
  ${mediaQuery('small')} {
    max-width: 275px;
  }
`;

export const StepCardImg = styled.img`
  width: 100%;
  height: 160px;
  object-fit: contain;
  margin-top: 20px;
`;

export const StepCardTitle = styled.p`
  ${responsiveFontSize(26, 1)};
  color: ${(props) => props.theme.color.purple.default};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  margin: 20px;
`;

export const StepCardText = styled.p`
  margin: 0 40px;
  font-weight: 500;
`;

// MORE

export const MoreCardsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 75px;
  flex-wrap: wrap;
`;

export const MoreCardWrapper = styled(Link)`
  display: block;
  padding: 20px;
  color: ${(props) => props.theme.color.dark.default};
  font-weight: 400;
`;

export const MoreCard = styled.div`
  min-width: 350px;
  box-shadow: 0px 0px 90px #00000029;
  height: 400px;
  background-color: ${(props) => props.theme.color.light.default};
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  ${mediaQuery('small')} {
    min-width: 275px;
  }
`;

export const MoreCardBackground = styled.img`
  object-fit: contain;
  height: 265px;
  position: absolute;
  width: auto;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
`;

export const MoreCardContentWrapper = styled.div<{
  backgroundColor?: 'purple' | 'blue' | 'yellow';
}>`
  background-color: ${(props) => props.theme.color[props.backgroundColor ?? 'yellow'].default};
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  height: 200px;
  position: absolute;
  bottom: 0;
  padding: 20px;
  padding-top: 40px;
  width: 100%;
`;

export const MoreCardTitle = styled.div`
  ${responsiveFontSize(26, 3)};
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  color: ${(props) => props.theme.color.light.default};
  margin: auto;
  padding-bottom: 15px;
`;

export const MoreCardButton = styled(Button)`
  margin-top: auto;
`;
